import React, { useState } from "react";
import { Container } from "@mui/material";
import styles from "./guidesHeaderBarStyles.js";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import GuidesTable from "../GuidesTable/index.js";
import DeliveryLotsGuidesTable from "../DeliveryLotsGuidesTable/index.js";
import GuidesIncidenceTable from "../GuidesIncidenceTable/index.js";
import { usePermissions } from "../../../hooks/permissions/usePermissions.js";

const GuidesTabBar = ({ guides = [], unassignedGuides = [], guidesInIncidence = [], isLoading, fetchGuides, fetchUnassingnedGuides, search, setHasItemsSelected, selectedGuides = [], setSelectedGuides }) => {
  const { hasAllPermissions } = usePermissions();


    const availableTabs = [];
    if (hasAllPermissions(["rte_vw", "rte_pac_vw"])) availableTabs.push("1");
    if (hasAllPermissions(["rte_vw", "rte_vwd_bat"])) availableTabs.push("2");
    if (hasAllPermissions(["rte_vw", "rte_inc_vw"])) availableTabs.push("3");

    const [value, setValue] = useState(availableTabs[0] || "1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setHasItemsSelected(false);
    setSelectedGuides([]);
  };

  return (
    <Container style={styles.primaryContainer}>
      <TabContext value={value}>
        <Container style={styles.mainContainer}>
          <Box sx={styles.tabContainer}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="fullWidth"
            >
              {(hasAllPermissions(["rte_vw", 'rte_pac_vw']) && <Tab label="Paquetes en matriz" value="1" />)}
              {(hasAllPermissions(["rte_vwd_bat", 'rte_vw']) && <Tab label="Lotes de entregas" value="2" />)}
              {(hasAllPermissions(["rte_inc_vw", 'rte_vw']) && <Tab label="Incidencias" value="3" />)}
            </TabList>
          </Box>
        </Container>

        <Container
          style={styles.mainContainer}
          sx={{ padding: "0 !important" }}
        >
          <Box sx={{ width: "100%" }}>
            {hasAllPermissions(["rte_vw", 'rte_vw']) && <TabPanel value="1">
              <GuidesTable
                guides={guides}
                search={search}
                fetchGuides={fetchGuides}
                fetchUnassingnedGuides={fetchUnassingnedGuides}
                isLoading={isLoading}
                setHasItemsSelected={setHasItemsSelected}
                selectedGuides={selectedGuides}
                setSelectedGuides={setSelectedGuides}
              />
            </TabPanel>}
            {hasAllPermissions(["rte_vwd_bat", 'rte_vw']) && (<TabPanel value="2">
              <DeliveryLotsGuidesTable
                guides={unassignedGuides}
                search={search}
                fetchGuides={fetchUnassingnedGuides}
                isLoading={isLoading}
              />
            </TabPanel>)}
            {hasAllPermissions(["rte_inc_vw", 'rte_vw']) && (<TabPanel value="3">
              <GuidesIncidenceTable
                guides={guidesInIncidence}
                search={search}
                isLoading={isLoading}
              />
            </TabPanel>)}
          </Box>
        </Container>
      </TabContext>
    </Container>
  );
};

GuidesTabBar.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func,
};

export default GuidesTabBar;
